import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@otp/ui';
import { LoginRuleCriteriaModal } from './modal';

interface AddLoginCriteriaButtonProps {
  onSubmit: (data: any) => void;
  className?: string;
}

export const AddLoginCriteriaButton = ({
  onSubmit,
  className,
}: AddLoginCriteriaButtonProps) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);

  return (
    <div className={className}>
      <Button
        variant="contained"
        color="primary"
        type="button"
        onClick={() => setShowModal(true)}
      >
        + {t('login-rules.form.add-criteria')}
      </Button>
      {showModal && (
        <LoginRuleCriteriaModal
          onClose={() => setShowModal(false)}
          onSubmit={onSubmit}
        />
      )}
    </div>
  );
};
